export const PLATFORM_CONFIG = {
  base: '/platform-config',
  channelTypes: '/platform-config/channel-types',
  channelTypesNew: '/platform-config/channel-types/new',
  channelType: (id: string) => `/platform-config/channel-types/${id}`,
  labels: '/platform-config/labels',
  labelsNew: '/platform-config/labels/new',
  label: (id: string) => `/platform-config/labels/${id}`,
  categories: '/platform-config/categories',
  categoriesNew: '/platform-config/categories/new',
  category: (id: string) => `/platform-config/categories/${id}`,
  statuses: '/platform-config/statuses',
  statusesNew: '/platform-config/statuses/new',
  status: (id: string) => `/platform-config/statuses/${id}`,
  channels: '/platform-config/channels',
  channelsNew: '/platform-config/channels/new',
  channel: (id: string) => `/platform-config/channels/${id}`,
  departments: '/platform-config/departments',
  departmentsNew: '/platform-config/departments/new',
  department: (id: string) => `/platform-config/departments/${id}`,
  departmentTeams: (deptId: string) => `/platform-config/departments/${deptId}/teams`,
  departmentTeam: (deptId: string, teamId: string) =>
    `/platform-config/departments/${deptId}/teams/${teamId}`,
  departmentTeamsNew: (deptId: string) => `/platform-config/departments/${deptId}/teams/new`,
  sla: '/platform-config/sla',
  slaNew: '/platform-config/sla/new',
  slaRule: (id: string) => `/platform-config/sla/${id}`,
  sources: '/platform-config/sources',
  sourcesNew: '/platform-config/sources/new',
  source: (id: string) => `/platform-config/sources/${id}`,
  routing: '/platform-config/routing',
  routingNew: '/platform-config/routing/new',
  routingRule: (id: string) => `/platform-config/routing/${id}`,
} as const;
